import { Component, OnDestroy, OnInit } from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { ComponentBaseComponent } from "../../../core/component-base.component";
import { AlertType } from "../../../enums/alert-type";
import { Message } from "../../../localization/message";
import { EndingInputDataBase } from "../../../models/ending";
import { SupplierUrlEncryptionInputData } from "../../../models/supplier-url-encryption";
import { EndService } from "../../../services/end.service";
import { Utilities } from "../../../utils/utilities";
import { CheesecakeStep } from "../../../enums/cheesecake-step";
import { IAfterComplete } from "../../../models/set-status-after-complete-output-data";
import { EndingOutputBase } from "../../../models/ending-output-base";
import { SetStatusResponseType } from "../../../enums/ending-page-response-type.enum";
import { ISetStatusRedirect, SetStatusRedirectOutputData } from "../../../models/set-status-redirect-output-data";
import { URLType } from "../../../enums/url-type";
import { Exception, isApiError } from "../../../core/exception";
import { Respondent, IRespondent } from "../../../models/respondent";
import { ISetStatusRouted } from "../../../models/set-status-routed-output-data";
import { SampleCubeUserBase } from "../../../models/samplecube-user";
import { IPolfishResponse } from "../../../models/profile/check-profile-response-base";
import { RvidData } from "../../../models/rvid";
import { IAfterCompleteReconfirmContact } from "../../../models/set-status-after-complete-reconfirm-contact-output-data";
import { IAfterCompleteConsent } from "../../../models/set-status-after-complete-consent-output-data";


export abstract class SetPixelURLComponent extends ComponentBaseComponent {

  imagePixelUrl: string = "";
  javaScriptUrl: string = "";
  redirectUrl: string = "";
  iframeurl: string = "";
  comScoreImageUrl: string = "";

  get hasSafeIframeUrl(): boolean {
    return !!this.iframeurl;
  }
  get hasSafeRedirectUrl(): boolean {
    return !!this.redirectUrl;
  }
  get hasSafeJavaScriptUrl(): boolean {
    return !!this.javaScriptUrl;
  }
  get hasSafeImagePixelUrl(): boolean {
    return !!this.imagePixelUrl;
  }
  get hasSafeComScoreImageUrl(): boolean {
    return !!this.comScoreImageUrl;
  }
  constructor(title?: string) {
    super(title);
  }
}

@Component({
  selector: "app-set-client-status",
  templateUrl: "./set-client-status.component.html",
  styleUrls: ["./set-client-status.component.scss"]
})
export class SetClientStatusComponent extends SetPixelURLComponent implements OnInit, OnDestroy {
  endingInputData: EndingInputDataBase = null;
  endingOutputData: EndingOutputBase = null;
  supplierUrlEncryptionInputData: SupplierUrlEncryptionInputData = new SupplierUrlEncryptionInputData();
  win: boolean = false;
  fail: boolean = false;
  quotaFail: boolean = false;

  get safeIframeUrl(): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(this.iframeurl);
  }
  get safeRedirectUrl(): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(this.redirectUrl);
  }
  get safeJavaScriptUrl(): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(this.javaScriptUrl);
  }
  get safeImagePixelUrl(): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(this.imagePixelUrl);
  }

  constructor(private endService: EndService, public sanitizer: DomSanitizer) {
    super("Loading ...");
    this.sessionStorageService.set("sc.step", CheesecakeStep.Landed);
  }

  async ngOnInit() {
    super.ngOnInit();
    const self = this;
    const urlParams = Utilities.parseQuery();
    // if (!!!urlParams["rid"]) {
    //   const respondent = self.cachedRespondent;
    //   let respondentToken = respondent.respondentToken;
    //   respondentToken += respondent.isTest ? "test" : "";
    //   urlParams["rid"] = respondentToken;
    // }

    self.endingInputData = EndingInputDataBase.processParameters(urlParams);

    if (!!!self.endingInputData.respondent.respondentToken) {
      self.displayAlert(Message.InvalidRespondent, AlertType.Error);
      return;
    }

    if (self.endingInputData.respondent.returnStatusId === 0) {
      self.displayAlert(Message.InvalidReturnStatus, AlertType.Error);
      return;
    }
    this.checkForTestRespondent();

    const data: RvidData = new RvidData(self.localStorageService.get("sc.rvid.data"));
    if (!!data) {
      self.endingInputData.relevantId = data.RVid || '';
      self.endingInputData.fraudProfileScore = Math.round(data.FraudRiskProbability) || 0;
      self.endingInputData.country = data.Country || '';
    }

    self.endingOutputData = await self.endService.setStatus(self.endingInputData, (error: Error) => {
      throw new Exception({
        message: error.message,
        data: isApiError((error as any).error) ? (error as any).error : null
      });
    });

    if (self.endingOutputData.respondent.isTest) {
      self.sessionStorageService.set("sc.respondent.test", self.endingOutputData.respondent);
      self.sessionStorageService.remove("sc.respondent");
    } else {
      self.sessionStorageService.set("sc.respondent", self.endingOutputData.respondent);
      self.sessionStorageService.remove("sc.respondent.test");
    }

    if (self.endingOutputData.setStatusResponseType === SetStatusResponseType.Success) {
      self.sessionStorageService.clear();
      self.displayAlert(Message.ThanksForParticipation);
      return;
    }

    if (self.endingOutputData.setStatusResponseType === SetStatusResponseType.Redirect) {
      self.sessionStorageService.clear();
      if ((self.endingOutputData as SetStatusRedirectOutputData).urlType == URLType.None) {
        window.location.href = ((self.endingOutputData as any) as ISetStatusRedirect).redirectUrl;
      }
      else if ((self.endingOutputData as SetStatusRedirectOutputData).urlType === URLType.JavaScript) {
        self.javaScriptUrl = self.redirectUrl;
      } else if ((self.endingOutputData as SetStatusRedirectOutputData).urlType === URLType.IFrame) {
        this.iframeurl = self.redirectUrl;
      } else if ((self.endingOutputData as SetStatusRedirectOutputData).urlType === URLType.ImagePixel) {
        this.imagePixelUrl = self.redirectUrl;
      }
      return;
    }

    if (self.endingOutputData.hasPages()) {
      if (self.sessionStorageService.get("sc.qualifications")) {
        self.sessionStorageService.remove("sc.qualifications");
      }
      if(self.endingOutputData.dropCookie){
        self.sessionStorageService.set("sc.qualifications", ((self.endingOutputData as any) as IAfterCompleteConsent).pages);
      } else {
        self.sessionStorageService.set("sc.qualifications", ((self.endingOutputData as any) as IAfterComplete).pages);
      }
      
    }
    if(self.endingOutputData.dropCookie){
      self.sessionStorageService.set("sc.vendorurl", ((self.endingOutputData as any) as IAfterCompleteConsent).redirectUrl);
      self.sessionStorageService.set("sc.urltype", ((self.endingOutputData as any) as IAfterCompleteConsent).urlType);
      this.navigateTo("/survey/after-complete-consent", true);
    }
    if (self.endingOutputData.setStatusResponseType === SetStatusResponseType.AfterComplete) {
      self.sessionStorageService.set("sc.vendorurl", ((self.endingOutputData as any) as IAfterComplete).redirectUrl);
      self.sessionStorageService.set("sc.urltype", ((self.endingOutputData as any) as IAfterComplete).urlType);
      this.navigateTo("/survey/after-complete", true);
    }
    if (self.endingOutputData.setStatusResponseType === SetStatusResponseType.AfterCompleteReconfirmContact) {
      self.sessionStorageService.set("sc.vendorurl", ((self.endingOutputData as any) as IAfterCompleteReconfirmContact).redirectUrl);
      self.sessionStorageService.set("sc.urltype", ((self.endingOutputData as any) as IAfterCompleteReconfirmContact).urlType);
      this.navigateTo("/survey/after-complete-reconfirm-contact", true);
    }
    
    if (self.endingOutputData.setStatusResponseType === SetStatusResponseType.Routed) {
      const routedSetStatusResponse: ISetStatusRouted = (self.endingOutputData as any) as ISetStatusRouted;
      const respondent: IRespondent = new Respondent(self.sessionStorageService.get(self.isTestUrl ? "sc.respondent.test" : "sc.respondent"));
      respondent.id = routedSetStatusResponse.respondentId;
      respondent.surveyId = routedSetStatusResponse.surveyId;
      respondent.respondentToken = routedSetStatusResponse.respondentToken;
      self.sessionStorageService.set(self.isTestUrl ? "sc.respondent.test" : "sc.respondent", respondent);
      let user: SampleCubeUserBase = SampleCubeUserBase.instanceFrom(self.localStorageService.get(self.isTestUrl ? "sc.profile.test" : "sc.profile"));

      if (!user && user.userId < 1) {
        user = self.localStorageService.get(self.isTestUrl ? "sc.profile.test" : "sc.profile");
      }
      self.sessionStorageService.set("sc.samplechainenable", routedSetStatusResponse.isSampleChainEnabled);
      self.sessionStorageService.set("sc.verifyrelevantid", routedSetStatusResponse.verifyRelevantId);
      self.sessionStorageService.remove("sc.sample.chain.data");
      self.sessionStorageService.set("sc.sampleChainDestinationPlatformId", routedSetStatusResponse.sampleChainDestinationPlatformId);
			self.sessionStorageService.set("sc.sampleChainDestinationSurveyNumber", routedSetStatusResponse.sampleChainDestinationSurveyNumber);
			self.sessionStorageService.set("sc.verifyrfgfingerprint", routedSetStatusResponse.verifyRFGFingerPrint);
      // if (self.sessionStorageService.get("sc.samplechainenable")) {
      //   self.sampleChainService.get(respondent.id, respondent.surveyId.toString(), respondent.country, respondent.respondentToken, user.userId.toString(), RequestType.Create, true);
      // }

      const polfishResponse: IPolfishResponse = (self.endingOutputData as any) as IPolfishResponse;
      self.sessionStorageService.set("sc.ispollfishenabled", self.isTestUrl === true ? false : polfishResponse.isPollfishEnabled);
      self.sessionStorageService.set("sc.isplrouterenabled", self.isTestUrl === true ? false : polfishResponse.isPLRouterEnabled);
      self.sessionStorageService.set("sc.clientinvokeurl", self.isTestUrl === true ? false : polfishResponse.clientInvokeUrl);
      self.sessionStorageService.set("sc.isRecontact", routedSetStatusResponse.isRecontact);
      self.sessionStorageService.set("sc.isPIDRouting", routedSetStatusResponse.isPIDRouting);
      self.sessionStorageService.set("sc.originaluserid", routedSetStatusResponse.originalUserId);

      self.ngOnDestroy();
      self.navigateTo("/survey", true);
    }

  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  checkForTestRespondent(): void {
    const self = this;
    if (self.endingInputData.respondent.respondentToken.indexOf("test") >= 0) {
      self.endingInputData.respondent.isTest = true;
      self.endingInputData.respondent.respondentToken = self.endingInputData.respondent.respondentToken.replace("test", "");
    }
  }


}
